import { render, staticRenderFns } from "./ABtn.vue?vue&type=template&id=586b1880&scoped=true"
import script from "./ABtn.vue?vue&type=script&lang=ts"
export * from "./ABtn.vue?vue&type=script&lang=ts"
import style0 from "./ABtn.vue?vue&type=style&index=0&id=586b1880&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586b1880",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AIcon: require('/codebuild/output/src4194940380/src/app/components/atoms/Media/AIcon.vue').default})
